export default __webpack_public_path__ + "static/media/map-logo.917b668e.svg";